module.exports = __webpack_public_path__ + "img/lecenie.899a72d2.png";